import { useEffect, useState } from 'react';
import NudosSearchbarDropdown from '../NudosSearchbarDropdown/NudosSearchbarDropdown';
import errorMessage from '../../../utils/errorMessage';
import { getConfigurationNotCompleteReasonOptions } from '../../../services/product-configuration.service';
import { IconfigurationNotCompleteReason } from '../../../types/product.configuration.types';

import './ConfigurationNotCompleteReasonsDropdown.scss';

const ConfigurationNotCompleteReasonsDropdown = ({
  clickSelectOptionCallback,
  currentValue,
  initialReasonId
}: {
  currentValue?: IconfigurationNotCompleteReason;
  clickSelectOptionCallback: (clickedOption: IconfigurationNotCompleteReason) => void;
  initialReasonId?: number;
}) => {
  const [dropdownOptions, setDropdownOptions] = useState<IconfigurationNotCompleteReason[]>([]);
  const [loadingOptions, setLoadingOptions] = useState(false);

  const formDropdownOptionsCallback = (
    rawOptions: IconfigurationNotCompleteReason[],
    clickOptionCallback?: (option: IconfigurationNotCompleteReason) => void
  ) => {
    return rawOptions.map((option, i) => {
      const handleSelectOption = () => {
        clickSelectOptionCallback(option);
        clickOptionCallback && clickOptionCallback(option);
      };
      return (
        <div className="optionContainer notCompleteOption" key={`option${option?.id}${i}`} onClick={handleSelectOption}>
          {option?.name}
        </div>
      );
    });
  };

  const formSelectedOptionUICallback = (rawSelectedOption: IconfigurationNotCompleteReason) => {
    return <div className="selectedOption">{rawSelectedOption?.name}</div>;
  };

  const filterBySearchStringCallback = (search: string, rawOptions: IconfigurationNotCompleteReason[]) => {
    return rawOptions.filter(option => {
      return option?.name?.toLowerCase().trim().includes(search.toLowerCase().trim());
    });
  };

  const getDropdownOptions = async () => {
    setLoadingOptions(true);
    try {
      const options = await getConfigurationNotCompleteReasonOptions();
      setDropdownOptions(options);
    } catch (error) {
      errorMessage();
    } finally {
      setLoadingOptions(false);
    }
  };

  useEffect(() => {
    getDropdownOptions();
  }, []);

  useEffect(() => {
    if (currentValue?.id) return;
    const initialReason = dropdownOptions.find(option => option?.id === initialReasonId);
    if (!initialReason) return;
    clickSelectOptionCallback(initialReason);
  }, [initialReasonId, dropdownOptions?.length]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="configurationNotCompleteReasonsDropdown">
      <NudosSearchbarDropdown
        customClassname="notCompletedeasonsDropdown"
        label="Indica por qué no se pudo completar"
        componentSize="medium"
        customPlaceholder="Selecciona el motivo"
        isFilled={!!currentValue}
        currentValue={currentValue}
        includeMagnifierIcon={false}
        rawOptions={dropdownOptions}
        formDropdownOptionsCallback={formDropdownOptionsCallback}
        formSelectedOptionUICallback={formSelectedOptionUICallback}
        filterBySearchStringCallback={filterBySearchStringCallback}
        closesOnChangeSelection
        showSkeletonLoader={loadingOptions}
      />
    </div>
  );
};

export default ConfigurationNotCompleteReasonsDropdown;
